import { SB, createMessage } from '@play-co/replicant';
import createMessages from '../config/messages/createMessages';
import {
  buddiesAddPlayerToParty,
  buddiesAddInviteReceived,
  buddiesRemoveInvite,
  buddiesAddPartyPlayerScore,
} from './buddies.modifiers';
import { buddiesCanSendOrReceiveInvite } from './buddies.getters';

export const buddiesMessages = createMessages({
  buddiesAddInviteReceived: createMessage(
    SB.object({}),
    (state, args, meta) => {
      if (!buddiesCanSendOrReceiveInvite(state, meta.timestamp)) return;

      buddiesAddInviteReceived(state, {
        id: meta.senderId,
        now: meta.timestamp,
      });
    },
  ),

  buddiesRemoveInvite: createMessage(SB.object({}), (state, args, meta) => {
    buddiesRemoveInvite(state, {
      id: meta.senderId,
      now: meta.timestamp,
    });
  }),

  buddiesAddPlayerToParty: createMessage(SB.object({}), (state, args, meta) => {
    buddiesAddPlayerToParty(state, {
      id: meta.senderId,
      now: meta.timestamp,
    });
  }),

  buddiesAddPartyPlayerScore: createMessage(
    SB.object({ score: SB.int() }),
    (state, args, meta) => {
      buddiesAddPartyPlayerScore(state, {
        id: meta.senderId,
        score: args.score,
        now: meta.timestamp,
      });
    },
  ),
});
